// Persistent "who last signed in on this device" marker.
//
// Product decision: once a device is used by a team member (agent /
// supervisor), that device becomes a "team device". It should:
//   • Never show the marketing landing page.
//   • Never expose "Create a workspace" or the marketing chat widget.
//   • Auto-route hellobyflow.com → /login for a clean workspace entry.
//
// Admins / owners are considered "operator" devices and keep the full
// experience (marketing pages, landing hero, workspace creation link).
//
// The marker survives logout on purpose — the ask is that team-member
// devices are hardened for staff use, not that we forget them on log-out.
//
// Values: "agent" | "supervisor" | "admin" | "owner" | null

const KEY = "hbf.device_role";

export function setDeviceRole(role) {
  try {
    if (!role) return;
    window.localStorage.setItem(KEY, role);
    window.dispatchEvent(new Event("hbf:device-role-change"));
  } catch (_) { /* private mode / SSR */ }
}

export function getDeviceRole() {
  try { return window.localStorage.getItem(KEY) || null; }
  catch (_) { return null; }
}

export function clearDeviceRole() {
  try {
    window.localStorage.removeItem(KEY);
    window.dispatchEvent(new Event("hbf:device-role-change"));
  } catch (_) { /* noop */ }
}

/** True when this device has ever been used by an agent or supervisor. */
export function isTeamDevice() {
  const r = getDeviceRole();
  return r === "agent" || r === "supervisor";
}
